/* Noorns redesign: the blog post page (sections/noorns-article.liquid).
   Does in the browser what the mockup's build script (src/page_post.py transform()) did to
   the post body, since Liquid can't parse the body:
   - gives each h2 an id and fills the contents lists (desktop rail, phone list)
   - marks outside links as citations (arrow mark) and lists them under "Sources in this post"
   - swaps a YouTube iframe for a click-to-load facade (no YouTube request until play)
   - wraps tables so they scroll on their own on a narrow screen, and drops inline styles
   - styles the closing "See what's in the ... report" line as a soft pill
   And the page's own behavior: the contents marker, and the "Back to top" pill.
   Horizon 4.2 scrolls an inner box (.page-wrapper) on wide screens and the window on phones,
   so scroll listeners and scrolling use whichever is scrolling. */
(function () {
  var root = document.getElementById('noorns-post');
  if (!root) return;
  var body = document.getElementById('post-body');

  var EXT = '<svg class="ext" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7M9 7h8v8"/></svg>';
  var PLAY = '<svg width="30" height="30" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="#fff"/></svg>';

  function slug(t) {
    var words = t.toLowerCase().replace(/'/g, '').replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/), out = '';
    for (var i = 0; i < words.length; i++) {
      if (out.length + words[i].length > 40) break;
      out = out ? out + '-' + words[i] : words[i];
    }
    return out || 'section';
  }

  if (body) {
    /* headings and contents */
    var heads = [], used = {};
    body.querySelectorAll('h2').forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      var id = h.id || ('s-' + slug(text));
      while (used[id]) id += '-2';
      used[id] = 1; h.id = id;
      heads.push({ id: id, text: text });
    });
    if (heads.length > 1) {
      var toc = document.getElementById('post-contents'), tocPhone = document.getElementById('post-contents-phone');
      heads.forEach(function (h) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.className = 'toc-link'; a.href = '#' + h.id; a.textContent = h.text; li.appendChild(a);
        if (toc) toc.querySelector('ol').appendChild(li);
        var li2 = document.createElement('li'), a2 = document.createElement('a');
        a2.className = 'toc-link-phone'; a2.href = '#' + h.id; a2.textContent = h.text; li2.appendChild(a2);
        if (tocPhone) tocPhone.querySelector('ol').appendChild(li2);
      });
      if (toc) toc.hidden = false;
      if (tocPhone) tocPhone.hidden = false;
    }

    /* outside links: citation mark, and the Sources list */
    var sources = [], host = location.hostname.replace(/^www\./, '');
    body.querySelectorAll('a[href]').forEach(function (a) {
      var u;
      try { u = new URL(a.getAttribute('href'), location.href); } catch (_) { return; }
      var h = u.hostname.replace(/^www\./, '');
      if (!/^https?:$/.test(u.protocol) || h === host || h === 'noorns.com' || /(^|\.)noorns\.com$/.test(h)) {
        if (/\/products\//.test(u.pathname)) a.classList.add('to-report');
        return;
      }
      /* links to YouTube (video timestamps, the channel) are not citations */
      if (/(^|\.)(youtube\.com|youtu\.be|youtube-nocookie\.com)$/.test(h)) return;
      a.classList.add('cite');
      if (!a.querySelector('.ext')) a.insertAdjacentHTML('beforeend', EXT);
      if (!a.rel) a.rel = 'noopener';
      sources.push({ text: (a.textContent || '').trim(), dom: h, href: u.href });
    });
    /* One list of sources (walk finding N5, 2026-10-11): when the post has its own References or Sources list,
       the panel would repeat it, so it stays hidden. */
    var ownRefs = [].some.call(body.querySelectorAll('h2,h3,h4,h5,h6,p,div'), function (el) {
      if (/^(P|DIV)$/.test(el.tagName) && !(el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName))) return false;
      return /^\s*(references|sources|citations|bibliography|further reading)\s*:?\s*$/i.test(el.textContent || '');
    });
    if (sources.length && !ownRefs) {
      var sd = document.getElementById('post-sources');
      if (sd) {
        sd.querySelector('.n').textContent = sources.length;
        var ol = sd.querySelector('ol');
        sources.forEach(function (s, i) {
          var li = document.createElement('li'), a = document.createElement('a'), d = document.createElement('span');
          li.id = 'source-' + (i + 1);
          a.href = s.href; a.rel = 'noopener'; a.textContent = s.text ? s.text.charAt(0).toUpperCase() + s.text.slice(1) : s.dom;
          d.className = 'src-dom'; d.textContent = s.dom;
          li.appendChild(a); li.appendChild(document.createTextNode(' ')); li.appendChild(d); ol.appendChild(li);
        });
        sd.hidden = false;
      }
    }

    /* YouTube iframe -> click-to-load facade */
    var vidN = 0;
    body.querySelectorAll('iframe[src*="youtube.com/embed/"], iframe[src*="youtube-nocookie.com/embed/"]').forEach(function (f) {
      var m = f.src.match(/embed\/([A-Za-z0-9_-]{6,})/);
      if (!m) return;
      var id = m[1], title = f.getAttribute('title') || '';
      /* the editor's default iframe title says nothing about the video */
      if (/^youtube video player$/i.test(title.trim())) title = '';
      vidN += 1;
      var fig = document.createElement('figure');
      fig.className = 'vid'; fig.id = vidN === 1 ? 'post-video' : 'post-video-' + vidN;
      var a = document.createElement('a');
      a.className = 'vid-facade'; a.href = 'https://www.youtube.com/watch?v=' + id; a.setAttribute('data-yt', id);
      a.setAttribute('aria-label', title ? 'Play the video: ' + title : 'Play the video');
      var img = document.createElement('img');
      img.alt = ''; img.loading = 'lazy'; img.width = 1280; img.height = 720;
      img.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
      img.addEventListener('load', function () { if (img.naturalWidth < 200 && !img.dataset.fb) { img.dataset.fb = 1; img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg'; } });
      img.addEventListener('error', function () { if (!img.dataset.fb) { img.dataset.fb = 1; img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg'; } });
      a.appendChild(img);
      a.insertAdjacentHTML('beforeend', '<span class="vid-play" aria-hidden="true"><span class="vp-icon">' + PLAY + '</span><span class="vp-label">Play the video</span></span>');
      fig.appendChild(a);
      var cap = document.createElement('figcaption'), st = document.createElement('strong'), sp = document.createElement('span');
      if (title) { st.textContent = title; cap.appendChild(st); }
      var line = body.getAttribute('data-video-caption');
      if (line) { sp.textContent = line; cap.appendChild(sp); }
      fig.appendChild(cap);
      var wrap = f.parentElement;
      if (wrap && wrap !== body && wrap.tagName === 'DIV' && wrap.children.length === 1) wrap.replaceWith(fig); else f.replaceWith(fig);
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var p = document.createElement('iframe');
        p.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        p.title = title || 'Video';
        p.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        p.allowFullscreen = true;
        p.referrerPolicy = 'strict-origin-when-cross-origin'; /* YouTube refuses embeds that send no referrer (error 153) */
        a.replaceWith(p);
        p.focus();
      });
    });
    if (!vidN) { var wl = document.getElementById('post-watch-link'); if (wl) { var dt = wl.previousElementSibling; wl.remove(); if (dt && dt.classList.contains('dot')) dt.remove(); } }

    /* tables: scroll wrapper, no inline styles; genotype and marker cells get the mono style */
    body.querySelectorAll('table').forEach(function (t, i) {
      t.removeAttribute('style');
      t.querySelectorAll('[style]').forEach(function (c) { c.removeAttribute('style'); });
      t.querySelectorAll('td').forEach(function (td) {
        var v = (td.textContent || '').trim();
        if (/^rs\d+$/i.test(v) || /^[ACGT]{1,2}([\/ ][ACGT]{1,2})?$/.test(v) || /^(--|0 ?0)$/.test(v)) td.classList.add('mono');
      });
      if (!t.parentElement.classList.contains('tbl')) {
        var w = document.createElement('div'); w.className = 'tbl'; w.id = 'post-table-' + (i + 1);
        t.parentNode.insertBefore(w, t); w.appendChild(t);
      }
    });

    /* in-body pictures get the figure styling */
    body.querySelectorAll('picture, p > img:only-child').forEach(function (p) {
      var host = p.closest('p') || p;
      if (host.parentElement === body) host.classList.add('inbody');
    });

    /* the closing "See what's in the ... report" line */
    body.querySelectorAll('p > strong > a.to-report:only-child, p > a.to-report:only-child').forEach(function (a) {
      var p = a.closest('p');
      if (p && (p.textContent || '').trim() === (a.textContent || '').trim()) p.classList.add('cta-line');
    });
  }

  /* which element scrolls */
  var scroller = function () {
    var el = root.parentElement;
    while (el && el !== document.body && el !== document.documentElement) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return window;
  };
  var scrollTop = function () { var s = scroller(); return s === window ? window.scrollY : s.scrollTop; };

  /* contents marker and Back to top */
  var links = Array.prototype.slice.call(root.querySelectorAll('.toc-link'));
  var targets = links.map(function (l) { return document.getElementById(l.getAttribute('href').slice(1)); });
  var tt = document.getElementById('back-to-top');
  var tick = false;
  function update() {
    tick = false;
    if (links.length) {
      var cur = null;
      targets.forEach(function (h) { if (h && h.getBoundingClientRect().top < window.innerHeight * 0.35) cur = h; });
      var id = cur ? cur.id : (targets[0] && targets[0].id);
      links.forEach(function (l) { l.setAttribute('aria-current', l.getAttribute('href') === '#' + id ? 'true' : 'false'); });
    }
    if (tt) { var on = scrollTop() > window.innerHeight * 1.5; tt.classList.toggle('show', on); tt.inert = !on; }
  }
  document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true, capture: true });
  update();

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('.to-top-link');
    if (!t) return;
    ev.preventDefault();
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scroller().scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' });
    var h = document.getElementById('post-title');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  });
})();
